import { useNavigate } from 'react-router-dom';

/* CSS */
import styles from "./style/statDetails.module.css";

/* Avatar */
import default_avatar from '../../../assets/icons/default_avatar.svg';

/* Icons */
import first_place from '../../../assets/icons/first_place.png';
import second_place from '../../../assets/icons/second_place.png';
import third_place from '../../../assets/icons/third_place.png';

const placeIcons = [first_place, second_place, third_place];

const BestBuddyDetail = ({ buddies }) => {

    const navigate = useNavigate();

    if (!buddies || buddies.length === 0) {
        return (
            <div className={styles.empty}>
                You haven't got any travel buddy yet
            </div>
        )
    }

    return (
        <div className={styles.list}>
            {buddies.map((buddy, index) => {
                const placeIcon = placeIcons[index];

                return (
                    <div key={buddy.user_id} className={styles.buddyRow}>
                        {placeIcon && (
                            <img
                                src={placeIcon}
                                className={styles.placeIcon}
                                alt={`Rank ${index + 1}`}
                                style={index === 0 ? { top: '-4px' } : { top: '-16px' }}
                            />
                        )}

                        {/* Header: avatar + name + trip count */}
                        <div className={styles.buddyHeader}>
                            <img
                                className={styles.avatar}
                                src={buddy.profile_picture_url || default_avatar}
                                alt={buddy.display_name}
                                loading='lazy'
                            />
                            <div className={styles.rowMain}>
                                <div className={styles.rowTitle}>{buddy.display_name}</div>
                                <div className={styles.rowSub}>
                                    {`${buddy.sharedCount} ${buddy.sharedCount === 1 ? 'trip' : 'trips'} together`}
                                </div>
                            </div>
                        </div>

                        {/* Trip chips */}
                        <div className={styles.buddyTrips}>
                            {buddy.trips.map((trip) => (
                                <button
                                    key={trip.id}
                                    type="button"
                                    className={styles.tripChip}
                                    onClick={() => navigate(`/trip/${trip.id}`)}
                                >
                                    {trip.title}
                                </button>
                            ))}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default BestBuddyDetail;